module.exports = __webpack_public_path__ + "img/icon-tw-mr.057b8b40.svg";